module.exports = __webpack_public_path__ + "img/PEUGEOT_301.399f80ab.jpg";